// Environment variables — Vite replaces import.meta.env.* at build time.
// IMPORTANT: Do not wrap these in eval() or dynamic accessors — Vite
// must see the literal import.meta.env.KEY to perform static replacement.

export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api';
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || '';
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || '';
export const NODE_ENV = import.meta.env.MODE || 'development';
